var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1419_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.3125C4.875 3.3125 2.20625 5.25625 1.125 8C2.20625 10.7438 4.875 12.6875 8 12.6875C11.125 12.6875 13.7937 10.7438 14.875 8C13.7937 5.25625 11.125 3.3125 8 3.3125ZM8 11.125C6.275 11.125 4.875 9.725 4.875 8C4.875 6.275 6.275 4.875 8 4.875C9.725 4.875 11.125 6.275 11.125 8C11.125 9.725 9.725 11.125 8 11.125ZM8 6.125C6.9625 6.125 6.125 6.9625 6.125 8C6.125 9.0375 6.9625 9.875 8 9.875C9.0375 9.875 9.875 9.0375 9.875 8C9.875 6.9625 9.0375 6.125 8 6.125Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1419_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye2);
export default __webpack_public_path__ + "static/media/eye2.f1bdc9e238ace1b4ac2d720aa15a021a.svg";
export { ForwardRef as ReactComponent };